import {
  HELPDESK_TOOL_DESCRIPTIONS,
  HELPDESK_TOOL_LABELS,
  HELPDESK_TOOLS,
  type HelpdeskToolName,
} from '@workspace/types';

export const MESA_TOOL_OPTIONS = HELPDESK_TOOLS.map(name => ({
  name,
  label: HELPDESK_TOOL_LABELS[name],
  description: HELPDESK_TOOL_DESCRIPTIONS[name],
})) satisfies Array<{ name: HelpdeskToolName; label: string; description: string }>;

/** Con todas tildadas se guarda la lista vacía: la mesa recibe también las herramientas nuevas. */
export function mesaToolsToPersist(selected: readonly string[]): string[] {
  const complete = MESA_TOOL_OPTIONS.every(option => selected.includes(option.name));
  return complete ? [] : [...selected];
}
